import ThankYouPage from '../forms/ThankYouPage'

const RoofLandingThankYou = () => (
    <ThankYouPage returnPath="/landing-roof" contentCategory="Roof" landingMode />
)

export default RoofLandingThankYou
